import { useState, useRef } from 'react'

import { EModalType } from '../enums'
import { openModal, closeModal } from './useModal'
import { apiService } from 'lib/services/api'
import { serializeFormData } from 'lib/utils/form'
import type { ApiError } from 'lib/types/api'
import type { FormErrors, SignUpFormData } from 'lib/types/forms'

export const useSignUpForm = () => {
  const formRef = useRef<HTMLFormElement>(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [errors, setErrors] = useState<FormErrors>({})

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (!formRef.current || isSubmitting) return

    setErrors({})
    setIsSubmitting(true)

    try {
      const formData = serializeFormData<SignUpFormData>(formRef.current)
      const data = await apiService.signUp(formData)

      formRef.current.reset()
      closeModal()

      if (!data.verified) openModal(EModalType.NOT_VERIFIED)
    } catch (error) {
      const apiError = error as ApiError
      setErrors(apiError)
    } finally {
      setIsSubmitting(false)
    }
  }

  return {
    formRef,
    isSubmitting,
    errors,
    handleSubmit,
  }
}
